import { Injectable } from '@angular/core';
import { Observable, Subject, map } from 'rxjs';

import { Search, SearchPage, ShipperResponse } from 'tms-lib';
import { ShipperBookingValidation, ShipperInterfaceHeader, SupplierAddress } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShipperInterfaceHeaderService extends TmsWebBaseEditCreateService<
  ShipperInterfaceHeader,
  ShipperInterfaceHeader
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShipperInterfaceHeader', $localize`Shipper Interface Header`);
  }

  bookShipping(id: string, shippingNotes: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/BookShipping`, { id, shippingNotes });
  }

  /** The checks Book Shipping makes, run on the saved record (by shipper interface id) without booking. */
  validateBooking(id: string): Observable<ShipperBookingValidation> {
    return this.httpService.get<ShipperBookingValidation>(`${this.apiUrl}/${id}/ValidateBooking`);
  }

  reprintLabel(id: string, shipperInterfaceHeaderId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ReprintLabel`, {
      id,
      shipperInterfaceHeaderId,
    });
  }

  changeShipper(shipperId: string, documentId: string, confirmPackDelete = false): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ChangeShipper`, {
      shipperId,
      documentId,
      confirmPackDelete,
    });
  }

  /** The manifest shipper's own addresses, for a manifest's Delivery Address box (AC-33). `id` is the shipper. */
  manifestShipperAddressSearch(model: Search): Observable<SupplierAddress[]> {
    return this.httpService
      .post<SearchPage<SupplierAddress>>(`${this.apiUrl}/ManifestShipperAddressSearch`, model)
      .pipe(map((searchPage: SearchPage<SupplierAddress>) => searchPage.results));
  }
}
